import { fnPostUrl } from "../axios/Api"

export const postLogin = (data) => {
    const apiRequest = {
        endpoint: "/Wstng/Login",
        body: data,
    }

    return fnPostUrl(apiRequest)
}